import React from "react";
import { InputContainer } from "..";
import { Input } from "./TextInput.styled";

export const TextInput = ({
  id,
  label,
  value,
  onChange,
  maxLen = 200,
  invalid,
  placeholder = "",
  isRequired = false,
  flex,
  width
}) => {
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length <= maxLen) {
      onChange(event);
    }
  };

  return (
    <InputContainer
      id={id}
      label={label}
      maxLen={maxLen}
      textLen={value?.length}
      isRequired={isRequired}
      flex={flex}
      width={width}
      render={(ID) => (
        <Input
          id={ID}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleInputChange}
          invalid={invalid}
        />
      )}
    />
  );
};
